import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Leaderboard = lazy(() => import("@/pages/Leaderboard"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/leaderboard")({
  component: () => (
    <ProtectedRoute>
      <Leaderboard />
    </ProtectedRoute>
  ),
});
